import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiResponse } from '@fleet/model';
import { paths } from '@fleet/environment';
import { encodeParams, handleApiError } from '@fleet/utilities';

@Injectable({
  providedIn: 'root',
})
export class StripeApiService {
  host: string;
  constructor(private http: HttpClient, @Inject('env') env: any) {
    // this.host = env.host + paths.stripe;
    this.host = env.host + paths.stripeIntegration;
  }

  /**
   * Return the public key for the stripe account
   *
   * @return Observable<string>
   */
  getPublicKey(): Observable<any> {
    return this.http
      .get<string>(`${this.host}/publicKey`)
      .pipe(catchError(handleApiError));
  }

  getIntegrationKey(intergrationKeyId: string): Observable<any> {
    return this.http
      .get<string>(`${this.host}/key/${intergrationKeyId}`)
      .pipe(catchError(handleApiError));
  }

  // searchStripeConfigurations(params: any): Observable<any> {
  //   return this.http
  //     .get(`${this.host}/search`, {
  //       params: encodeParams(params),
  //     })
  //     .pipe(catchError(handleApiError));
  // }

  // getStripeConfiguration(stripeConfigurationId: string): Observable<any> {
  //   return this.http
  //     .get(`${this.host}/${stripeConfigurationId}`)
  //     .pipe(catchError(handleApiError));
  // }

  sync(stripeConfigurationId: string): Observable<any> {
    return this.http
      .post(`${this.host}/${stripeConfigurationId}/sync`, {})
      .pipe(catchError(handleApiError));
  }

  install(): Observable<any> {
    return this.http
      .get(`${this.host}/install`)
      .pipe(catchError(handleApiError));
  }

  deleteConfiguration(stripeConfigurationId: string): Observable<any> {
    return this.http
      .delete(`${this.host}/${stripeConfigurationId}`)
      .pipe(catchError(handleApiError));
  }

  refreshToken(stripeConfigurationId: string): Observable<any> {
    return this.http
      .post(`${this.host}/${stripeConfigurationId}/refreshToken`, {})
      .pipe(catchError(handleApiError));
  }
  suspendConfiguration(stripeConfigurationId: string): Observable<any> {
    return this.http
      .post(`${this.host}/${stripeConfigurationId}/suspend`, {})
      .pipe(catchError(handleApiError));
  }

  activateConfiguration(stripeConfigurationId: string): Observable<any> {
    return this.http
      .post(`${this.host}/${stripeConfigurationId}/activate`, {})
      .pipe(catchError(handleApiError));
  }

  searchStripeKeys(params: any): Observable<any> {
    return this.http
      .get(`${this.host}/key`, {
        params: encodeParams(params),
      })
      .pipe(catchError(handleApiError));
  }

  createStripeKey(payload: any): Observable<any> {
    return this.http
      .post(`${this.host}/key`, payload)
      .pipe(catchError(handleApiError));
  }

  updateStripeKey(intergrationId: string, payload: any): Observable<any> {
    return this.http
      .put(`${this.host}/key/${intergrationId}`, payload)
      .pipe(catchError(handleApiError));
  }

  deleteStripeKey(intergrationId: string): Observable<any> {
    return this.http
      .delete(`${this.host}/key/${intergrationId}`)
      .pipe(catchError(handleApiError));
  }
}
